<h1>Are you a part of {{model.name}}?</h1>

<p>You are about to get into InterSystems Startup Hub.<br>
  Please confirm that you are a representative of “{{ model.name }}”</p>

<button class="btn-primary" (click)="onConfirmClick()">Yes, Get Me Through</button>
